import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=ac8ab7c8&scoped=true&"
import script from "./Advertisement.vue?vue&type=script&lang=js&"
export * from "./Advertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8ab7c8",
  null
  
)

export default component.exports